import React from 'react';
import { Helmet } from "react-helmet";

//CORE COMPOENTNS
import { ThemeProvider, styled } from '../../../components-core/packages/components-core/dist/theme-provider';
import scroll from '../lead-section/LeadSection'
//LAYOUT
import {
    Container,
    ContainerGutter,
    ContainerWrap,
    ContainerPadding,
    ContainerHorizontalAlignment
} from '../../../components-core/packages/components-core/dist/container';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';

//STYLE
import { Text, TextAppearance, TextAlignment, TextColor } from '../../../components-core/packages/components-core/dist/text';
import { Button, ButtonAppearance } from '../../../components-core/packages/components-core/dist/button'
import LayoutTwo from '../../components/layouttwo'
import { Link } from '../../../components-core/packages/components-core/dist/link/index';


import { Layout } from '../../../components-core/packages/components-core/dist/layout/index';
import { IntegratorRoot } from '../../../components-core/packages/components-core/dist/integrator-root/index';

const TopContainerPrice = styled.div`
    width: 100vw;
    
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
`;

const TopContainer = styled.div`
    width: 100vw;
`;

const LineContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;

    padding-right: ${props => props.position === 'left' ? '8px' : 0};
    padding-left: ${props => props.position === 'right' ? '8px' : 0};
`;


const Line = styled.hr`
    width: 100%;
    height: 2px;
    margin: 0;
`;

class UserDescription extends React.Component {

    constructor() {
        super();
        this.state = {
        }
    }

    renderTitle() {
        const isMobile = typeof window !== `undefined` && window.innerWidth <= 768;
        if (isMobile) {
            return (
                <Container
                    padding={padding4Dimensions}
                    horizontalAlign={ContainerHorizontalAlignment.center}
                >
                    <h2><Text textAlign={TextAlignment.center} appearance={TextAppearance.headline0400}>
                        Hoşgeldin,&nbsp;<br />
                        <Text bold appearance={TextAppearance.headline0400} >
                            Serifhan Isıklı
                        </Text>
                    </Text></h2>
                </Container>
            )
        } else {
            return (
                <Container
                    padding={padding4Dimensions}
                    horizontalAlign={ContainerHorizontalAlignment.center}
                >
                    <h2><Text textAlign={TextAlignment.center} appearance={TextAppearance.headline0400}>
                        Hoşgeldin,
                    <Text bold appearance={TextAppearance.headline0400} >
                            Şerifhan Işıklı
                    </Text>
                    </Text></h2>
                </Container>
            )
        }

    }


    renderExit() {

        return (
            <Container
                horizontalAlign={ContainerHorizontalAlignment.center}
                padding={{ left: globalPadding, right: globalPadding }}
            >
                <Link>
                    <Text appearance={TextAppearance.copy0150} color={TextColor.inherit}  >
                        Çıkış Yap
                    </Text>
                </Link>
            </Container>
        )
    }

    renderUserInformation() {

        const mainContainerPadding = {
            top: ContainerPadding.dynamic0300,
            bottom: ContainerPadding.dynamic0300
        }

        return (
            <Container
                padding={mainContainerPadding}
                horizontalAlign={ContainerHorizontalAlignment.center}
            >
                <Container
                    horizontalAlign={ContainerHorizontalAlignment.center}
                    stretchContent={true}
                    wrap={ContainerWrap.always}
                >
                    {this.renderTitle()}
                    {this.renderExit()}<br/>
                    {this.renderButtons()}
                </Container>
            </Container>
        )
    }

    renderButtons(){
        return(  
        <IntegratorRoot>
        <ThemeProvider>
            <TopContainer>
                <Layout appearance={buttonLaneLayoutAppearance}>
                    {renderLine('left')}
                    <Button 
                        onClick={() => window.open(this.props.custom9, '_blank')} 
                        stretchContent={true}
                    >
                        Servis Randevusu
                    </Button>
                    {renderLine('right')}
                </Layout>
            </TopContainer><br/><br/>
        </ThemeProvider>
    </IntegratorRoot>)
      
    }

    render() {
        return (
            <LayoutTwo theme={'main'}>
                <div style={{ marginTop: '100px' }}>

                    <Container horizontalAlign={ContainerHorizontalAlignment.center} padding={ContainerPadding.static200}>
                        <ThemeProvider theme={'main'}>
                            <Container wrap={ContainerWrap.never} stretchContent={true}>
                                <TopContainerPrice>
                                    {this.renderUserInformation()}
                                </TopContainerPrice>
                            </Container>
                        </ThemeProvider>
                    </Container>
                </div>
            </LayoutTwo>
        )
    }

}


const globalPadding = {
    [Breakpoints.b1920]: ContainerPadding.grid007,
    [Breakpoints.b1600]: ContainerPadding.grid006,
    [Breakpoints.b1280]: ContainerPadding.grid005,
    [Breakpoints.b960]: ContainerPadding.grid004,
    [Breakpoints.default]: ContainerPadding.grid002
}

const padding4Dimensions = {
    left: globalPadding,
    right: globalPadding,
    bottom: ContainerPadding.dynamic0100
}

const buttonLaneLayoutAppearance = {
    [Breakpoints.default]: [
        { name: '.', columns: 2 },
        { name: 'a', columns: 4 },
        { name: 'b', columns: 12 },
        { name: 'c', columns: 4 },
        { name: '.', columns: 2 }
    ],
    [Breakpoints.b560]: [
        { name: '.', columns: 2 },
        { name: 'a', columns: 6 },
        { name: 'b', columns: 8 },
        { name: 'c', columns: 6 },
        { name: '.', columns: 2 }
    ],
    [Breakpoints.b960]: [
        { name: '.', columns: 2 },
        { name: 'a', columns: 7 },
        { name: 'b', columns: 6 },
        { name: 'c', columns: 7 },
        { name: '.', columns: 2 }
    ],
    [Breakpoints.b1280]: [
        { name: '.', columns: 2 },
        { name: 'a', columns: 8 },
        { name: 'b', columns: 4 },
        { name: 'c', columns: 8 },
        { name: '.', columns: 2 }
    ]
}

const renderLine = (position) => (
    <LineContainer position={position}>
        <Line />
    </LineContainer>
)

export default UserDescription;